const SEARCH_RESULTS = 'Search Results';
const BROWSING_HISTORY = 'Browsing History';
const BROWSING_HISTORY_VIEW_ALL = 'Browsing History - View All';
const FEATURED_PRODUCTS = 'Featured Products';
const FREQUNETLY_PURCHASED = 'Frequently Purchased';
const FREQUENTLY_PURCHASED_VIEW_ALL = 'Frequently Purchased - View All';
const PRODUCTS_ON_SALE = 'Products on Sale';
const PRODUCTS_ON_SALE_VIEW_ALL = 'Products on Sale - View All';
const SHOP_BY_PREFIX = 'Shop By ';
const COMMON_LIST_BY_MODEL = 'Common List by Model';
const LIST_BY_MODEL_DIAGRAM = 'List by Model Diagram';
const UPLOAD_FILE = 'Upload File';
const LIST_FAVORITES = 'Favorites';
const LABEL_CART_PAGE_ADD_TO_CART = 'Cart Page - Add to Cart';
const LABEL_FAVORITES_ADD_TO_CART = 'Favorites - Add to Cart';
const LABEL_FAVORITES_ADD_LIST_TO_CART = 'Favorites - Add List to Cart';

export default {
  SEARCH_RESULTS,
  BROWSING_HISTORY,
  BROWSING_HISTORY_VIEW_ALL,
  FEATURED_PRODUCTS,
  FREQUNETLY_PURCHASED,
  FREQUENTLY_PURCHASED_VIEW_ALL,
  PRODUCTS_ON_SALE,
  PRODUCTS_ON_SALE_VIEW_ALL,
  SHOP_BY_PREFIX,
  COMMON_LIST_BY_MODEL,
  LIST_BY_MODEL_DIAGRAM,
  UPLOAD_FILE,
  LIST_FAVORITES,
  LABEL_CART_PAGE_ADD_TO_CART,
  LABEL_FAVORITES_ADD_TO_CART,
  LABEL_FAVORITES_ADD_LIST_TO_CART
};
